// src/config/categories.ts

export const HARDCODED_CATEGORIES: string[] = [
  'Sheet Metal',
  'Heating & Cooling Equipment',
  'Water Heaters & Tanks',
  'Indoor Air Quality',
  'Ventilation Fans',
  'Air Distribution',
  'Fireplaces',
  'Barbeques & Ovens',
  'Tools',
  'Venting',
  'Gas Supplies',
  'Refrigeration Supplies',
  'Plumbing Accessories',
  'Electrical Supplies',
  'Thermostats & Controls',
  'Replacement Parts',
  'Fasteners',
  'Safety Supplies',
  'Installation Accessories'
];
